import domReady from "@wordpress/dom-ready";

domReady(function () {
  document.querySelectorAll(".wp-block-group").forEach(initContainer);

  function initContainer(container) {
    const accordions = [...container.querySelectorAll("details")];

    for (const accordion of accordions) {
      accordion.addEventListener("transitionend", () => {
        if (accordion.getAttribute("open") === "closing") {
          accordion.open = false;
        }
      });

      const summary = accordion.querySelector("summary");
      if (!summary) {
        console.warn("Élément summary manquant dans l'accordéon", accordion);
        continue;
      }

      summary.addEventListener("click", (e) => {
        e.preventDefault();

        if (accordion.getAttribute("open") === "open") {
          close(accordion);
        } else {
          open(accordion);
          accordions.filter((o) => o.open && o !== accordion).forEach(close);
        }
      });
    }
  }

  async function open(acc) {
    const content = acc.querySelector(".content");

    // Vérification si l'élément content existe
    if (!content) {
      console.warn("Élément .content manquant dans l'accordéon", acc);
      return;
    }

    const initialHeight = acc.open ? content.getBoundingClientRect().height : 0;

    // Annuler les animations existantes seulement si getAnimations est supporté
    if (content.getAnimations) {
      content.getAnimations().forEach((a) => a.cancel());
    }

    acc.setAttribute("open", "open");
    const targetHeight = content.getBoundingClientRect().height;

    content.animate(
      { height: [`${initialHeight}px`, `${targetHeight}px`] },
      { duration: (targetHeight - initialHeight) * 1 }
    );
  }

  async function close(acc) {
    const content = acc.querySelector(".content");

    // Vérification si l'élément content existe
    if (!content) {
      console.warn("Élément .content manquant dans l'accordéon", acc);
      return;
    }

    acc.setAttribute("open", "closing");

    const h = content.getBoundingClientRect().height;

    // Annuler les animations existantes seulement si getAnimations est supporté
    if (content.getAnimations) {
      content.getAnimations().forEach((a) => a.cancel());
    }

    await content.animate({ height: [`${h}px`, 0] }, { duration: h * 1 })
      .finished;

    acc.open = false;
  }
});
